<template>
  <v-container fluid>
    <!-- <v-card> -->
      <v-card-title>
        <v-icon class="me-2">mdi-image</v-icon>
        Banners
      </v-card-title>
      <v-card-subtitle>Manage your banner content here</v-card-subtitle>
      <v-card-actions>
        <v-btn @click="openAddDialog" color="primary">
          <v-icon left>mdi-plus</v-icon>
          Add Banner
        </v-btn>
      </v-card-actions>

      <!-- List of Banners -->
      <v-row v-if="!loading && banners.length">
        <v-col v-for="(banner, index) in banners" :key="banner.banner_id" cols="12" md="6" lg="4">
          <v-card class="mx-auto my-4" >
            <v-img
              :src="getImageUrl(banner.banner_images[0]?.banner_image_name)"
              cover
            ></v-img>

            <v-card-title>{{ banner.title }}</v-card-title>
            <v-card-subtitle>{{ banner.subtitle }}</v-card-subtitle>

            <v-card-actions>
              <v-btn 
                @click="openEditDialog(banner)" 
                color="primary" 
                variant="flat" 
                size="small" 
                prepend-icon="mdi-pencil"
              >
                Edit
              </v-btn>
              <v-btn 
                @click="confirmDelete('banner', banner.banner_id)" 
                color="error" 
                variant="flat" 
                size="small" 
                prepend-icon="mdi-delete"
              >
                Delete
              </v-btn>
            </v-card-actions>

          </v-card>
        </v-col>
      </v-row>

      <!-- Loading Spinner -->
      <v-row v-if="loading">
        <v-col class="text-center">
          <v-progress-circular indeterminate></v-progress-circular>
        </v-col>
      </v-row>

      <!-- No Data Message -->
      <v-row v-else-if="!banners.length && !loading">
        <v-col class="text-center">
          <p>No banners available.</p>
        </v-col>
      </v-row>

      <!-- Add/Edit Banner Dialog -->
      <v-dialog v-model="dialog" max-width="600" persistent scrollable>
  <v-card>
    <v-toolbar>
      <v-toolbar-title><strong>{{ editMode ? 'Edit Banner' : 'Add Banner' }}</strong></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="dialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-form @submit.prevent="saveBanner">
        <v-text-field
        variant="outlined"
          v-model="currentBanner.title"
          label="Title (Optional)"
          required
        ></v-text-field>
        <v-text-field
        variant="outlined"
          v-model="currentBanner.subtitle"
          label="Subtitle (Optional)"
          required
        ></v-text-field>
        <v-text-field
        variant="outlined"
          v-model="currentBanner.button_text"
          label="Button Text (Optional)"
        ></v-text-field>
        <v-text-field
        variant="outlined"
          v-model="currentBanner.button_link"
          label="Button Link (Optional)"
        ></v-text-field>
        <v-file-input
        variant="outlined"
          v-model="bannerImage"
          label="Image (Direkomendasikan 1920 x 600px)"
          accept="image/*"
          @change="handleFileChange"
        ></v-file-input>

        <v-row v-if="previewImage">
          <v-col>
            <v-img :src="previewImage" alt="Image preview" max-height="200" />
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions class="justify-end">
      <div class="text-center">
        <v-btn
          prepend-icon="mdi-check-circle"
          type="submit"
          variant="flat"
          color="primary"
          @click="saveBanner"
        >
          {{ editMode ? 'Save Changes' : 'Add Banner' }}
        </v-btn>
        <v-btn
          prepend-icon="mdi-close-circle"
          @click="dialog = false"
          variant="flat"
          color="secondary"
        >
          Cancel
        </v-btn>
      </div>
    </v-card-actions>
  </v-card>
</v-dialog>


      <!-- Delete Confirmation Dialog -->
      <v-dialog v-model="confirmDialog" max-width="400px">
        <v-card>
          <v-card-title class="headline">{{ confirmMessage }}</v-card-title>
          <v-card-actions>
            <v-btn color="primary" @click="deleteConfirmed">Yes</v-btn>
            <v-btn color="grey" @click="confirmDialog = false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    <!-- </v-card> -->

    <v-snackbar
      v-model="snackbar.visible"
      :timeout="snackbar.timeout"
    >
      {{ snackbar.message }}
      <template v-slot:actions>
        <v-btn color="white" text @click="snackbar.visible = false"
          >Close</v-btn
        >
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      banners: [],
      loading: false,
      dialog: false,
      editMode: false,
      confirmDialog: false,
      confirmMessage: '',
      deleteType: '',
      deleteId: '',
      currentBanner: {
        banner_id: '',
        title: '',
        subtitle: '',
        button_text: '',
        button_link: '',
      },
      bannerImage: '',
      previewImage: '',
      snackbar: {
        visible: false,
        message: "",
        timeout: 5000,
      },
    };
  },
  methods: {
    showSnackbar(message, timeout = 3000) {
      this.snackbar.message = message;
      this.snackbar.timeout = timeout;
      this.snackbar.visible = true;
    },
    getImageUrl(imageName) {
      return `${this.$urlImage}storage/images/${imageName}`;
    },
    async fetchBanners() {
      this.loading = true;
      try {
        const response = await this.$axios.get('/banners', {
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
        });
        this.banners = response.data.data || [];
      } catch (error) {
        console.error('Error fetching banners:', error);
      } finally {
        this.loading = false;
      }
    },
    openAddDialog() {
      this.currentBanner = { id: '', title: '', subtitle: '', button_text: '', button_link: '' };
      this.bannerImage = '';
      this.previewImage = '';
      this.editMode = false;
      this.dialog = true;
    },
    openEditDialog(banner) {
      this.currentBanner = { ...banner };
      this.bannerImage = '';
      this.previewImage = this.getImageUrl(banner.banner_images[0]?.banner_image_name);
      this.editMode = true;
      this.dialog = true;
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.bannerImage = file;
        this.previewImage = URL.createObjectURL(file);
      }
    },
    async saveBanner() {
      const formData = new FormData();
      formData.append('title', this.currentBanner.title);
      formData.append('subtitle', this.currentBanner.subtitle);
      formData.append('button_text', this.currentBanner.button_text);
      formData.append('button_link', this.currentBanner.button_link);
      if (this.bannerImage) {
        formData.append('image', this.bannerImage);
      }

      try {
        if (this.editMode) {
          await this.$axios.post(`/banners/${this.currentBanner.banner_id}`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
          });
        } else {
          await this.$axios.post('/banners', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
          });
        }
        this.showSnackbar('Banner successfully saved')
        await this.fetchBanners();
        this.dialog = false;
      } catch (error) {
        this.showSnackbar('Error while saving banner')
      }
    },
    confirmDelete(type, banner_id) {
      this.deleteType = type;
      this.deleteId = banner_id;
      this.confirmMessage =
        type == 'banner' ? 'Are you sure you want to delete this banner?' : 'Are you sure you want to delete this image?';
      this.confirmDialog = true;
    },
    async deleteConfirmed() {
      try {
        if (this.deleteType == 'banner') {
          await this.deleteBanner(this.deleteId);
        } else if (this.deleteType == 'image') {
          await this.deleteImage(this.deleteId);
        }
      } catch (error) {
        console.error('Error deleting:', error);
      } finally {
        this.showSnackbar('Banner succesfully deleted')
        this.confirmDialog = false;
        this.deleteId = '';
        this.deleteType = '';
      }
    },
    async deleteBanner(banner_id) {
      try {
        await this.$axios.delete(`/banners/${banner_id}`, {
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
        });
        await this.fetchBanners();
      } catch (error) {
        this.showSnackbar('Error while deleting banner')
      }
    },
    async deleteImage(id) {
      try {
        await this.$axios.delete(`/banner-image/${id}`, {
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
        });
        await this.fetchBanners();
      } catch (error) {
        this.showSnackbar('Error while deleting image')
      }
    },
  },
  mounted() {
    this.fetchBanners();
  },
};
</script>
